import { css } from '@emotion/css';
import React from 'react';
import { BackButton } from '../buttons/BackButton';

interface ReportOverlayContainerProps {
  title: string;
  backButtonLabel: string;
}

export const ReportOverlayContainer: React.FC<ReportOverlayContainerProps> = ({
  children,
  title,
  backButtonLabel
}) => {
  return (
    <div
      className={css`
        width: 100%;
        height: 100%;
        background: #f5f1e3;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 10;

        * {
          font-family: system-ui, -apple-system, sans-serif;
          font-weight: bold;
        }
        header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 52px;
          padding: 0 4px;

          .space {
            width: 48px;
            height: 100%;
          }
        }
        h1 {
          font-size: 16px;
          color: #4d3906;
        }
        .body {
          width: 100%;
          height: calc(100% - 52px);
        }
      `}
    >
      <header>
        <BackButton ariaLabel={backButtonLabel} />
        <h1>{title}</h1>
        <div className="space" />
      </header>
      <div className="body">{children}</div>
    </div>
  );
};
